import type { DirectorStepFormValues } from "helpers/forms/au/directorTypes";
import { CompanyStore } from "services/company/companyStore";
import { DirectorEntity, DirectorStore } from "services/director/directorStore";
import { FormError } from "types/errors";

export class DirectorAcnStepStore {
  private readonly _directorStore: DirectorStore;
  private readonly _companyStore: CompanyStore;

  constructor(directorStore: DirectorStore, companyStore: CompanyStore) {
    this._directorStore = directorStore;
    this._companyStore = companyStore;
  }
  async updateMainDirector(formValues: DirectorStepFormValues, entity: DirectorEntity): Promise<void> {
    if (entity === DirectorEntity.Shares) {
      await this.updateShares(formValues);
    }
  }

  async updateShares(formValues: DirectorStepFormValues): Promise<void> {
    const {
      totalShares,
      totalCapital,
      directors: directorShares,
      directorsSignificantControl: directorSignificant,
    } = formValues || {};

    if (!totalShares || !totalCapital || !directorShares) {
      throw new FormError("Something went wrong");
    }

    await this._companyStore.updateShares(totalShares, totalCapital);

    for (const director of this._directorStore.directors) {
      const value = directorShares[director.id];
      const isSignificant = directorSignificant?.[director.id];
      await this._directorStore.updateShares(director.id, value ? parseInt(value) : undefined);
      await this._directorStore.updateSignificantControl(director.id, !!isSignificant);
    }
  }
}
